var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_17663)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 0.520508,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#4379F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9106 12.3538C10.4044 12.3538 9.99396 11.9434 9.99396 11.4371V10.5204C9.99396 10.0142 10.4044 9.60377 10.9106 9.60377C11.4169 9.60377 11.8273 10.0142 11.8273 10.5204V11.4371C11.8273 11.9434 11.4169 12.3538 10.9106 12.3538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53563 14.6454C9.53563 13.886 10.1512 13.2704 10.9106 13.2704C11.67 13.2704 12.2856 13.886 12.2856 14.6454C12.2856 15.4048 11.67 16.0204 10.9106 16.0204C10.1512 16.0204 9.53563 15.4048 9.53563 14.6454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2681 6.68086C10.3908 6.63909 9.65515 7.12914 9.52315 7.92114C9.43992 8.42051 8.96763 8.75787 8.46826 8.67464C7.96889 8.59141 7.63153 8.11912 7.71476 7.61974C8.0411 5.66174 9.8263 4.7768 11.3553 4.8496C12.1385 4.8869 12.9434 5.16801 13.5632 5.74716C14.1983 6.34069 14.5773 7.19089 14.5773 8.22877C14.5773 9.41247 14.1115 10.2903 13.3097 10.8248C12.5735 11.3156 11.671 11.4371 10.9106 11.4371C10.4044 11.4371 9.99396 11.0267 9.99396 10.5204C9.99396 10.0142 10.4044 9.60377 10.9106 9.60377C11.5252 9.60377 11.9977 9.49608 12.2928 9.2994C12.5222 9.14644 12.744 8.87841 12.744 8.22877C12.744 7.66249 12.55 7.30957 12.3115 7.08669C12.0576 6.84943 11.688 6.70086 11.2681 6.68086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_17663"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 0.520508,
    width: 24,
    height: 24,
    rx: 10,
    fill: "#4379F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.02638df09dc4d695a8ed02dc57dfbafd.svg";
export { ForwardRef as ReactComponent };